import {
  authenticateAsUser,
  authenticateUser,
  getDecodedToken,
  isTokenSoonExpired,
  refreshToken,
  removeToken,
  verifyToken,
} from './authentication-jwt.js'

async function logout() {
  removeToken()
}

// Impersonate user with a JWT token obtained from server
async function impersonateUser(username) {
  await authenticateAsUser(username)
}

export {
  authenticateUser,
  verifyToken as checkAuthentication,
  getDecodedToken as getAuthenticatedUser,
  isTokenSoonExpired as isAuthSoonExpired,
  impersonateUser as loginImpersonate,
  logout,
  refreshToken as refreshAuthentication,
  removeToken,
}
